export const SUBSCRIPTIONS_CACHE_KEY = 'subscriptions';

export enum SUBSCRIPTION_PLAN {
    // TODO: This will be renamed on https://auctane.atlassian.net/browse/PCK-3523
    PRO_PLUS = 'Packlink PRO Silver',
}

export const SUBSCRIPTION_PLANS_CACHE_KEY = 'subscription-plans';
export const SUBSCRIPTION_PLAN_PRICE_CACHE_KEY = 'subscription-plan-price';
